import type { BaseBridgeOptions, MessageBase } from './BaseBridge';
import { BaseBridge } from './BaseBridge';

export interface AndroidBridgeOptions extends BaseBridgeOptions {}

export class AndroidBridge extends BaseBridge {
  static get androidBridge() {
    return window.bridge;
  }
  constructor(options?: AndroidBridgeOptions) {
    if (!AndroidBridge.androidBridge) {
      throw new Error('Android not found');
    }

    super(options);
    this.initAndroidBridge();
  }
  private postMessage(msg: any) {
    AndroidBridge.androidBridge.send(JSON.stringify(msg));
  }
  private initAndroidBridge() {
    Object.assign(window, {
      haloBridge: {
        response: async (res: string) => {
          const data = JSON.parse(res);

          const { type } = data as MessageBase;

          switch (type) {
            case 'request': {
              const response = await this.handleRequest(data);
              this.postMessage(response);
              break;
            }
            case 'response':
              this.responseHandler(data);
              break;
            case 'notification':
              this.handleNotification(data);
              break;
          }
        },
      },
    });
  }
  request(method: string, params: Record<string, any> | undefined) {
    return this.requestHandler(method, params, this.postMessage);
  }
  notify(method: string, payload?: Record<string, any> | undefined) {
    this.postMessage({ type: 'notification', method, payload });
  }
  // TODO amo: dispose
  [Symbol.dispose]() {}
}
